// extracted by mini-css-extract-plugin
module.exports = {"highTopMargin":"qo","lowTopMargin":"qp","rightColumnWrapper":"qq","rightColumnTitle":"qr","title":"qs"};